import { createFileRoute, Link } from '@tanstack/react-router';
import { LightbulbIcon } from 'lucide-react';
import { PageContainer } from '@/components/layout/page-container';
import { PageHeader } from '@/components/layout/page-header';
import { Button } from '@/components/ui/button';
import { FeaturesRoadmap } from './-components/features-roadmap';

export const Route = createFileRoute('/_authenticated/_global/roadmap/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PageContainer>
      <PageHeader
        title="Roadmap"
        description="See what we're working on and what's coming soon"
        rightControls={
          <Link to="/feature-request">
            <Button variant="default" className="text-sm font-medium">
              <LightbulbIcon size={20} strokeWidth={3} />
              <span className="hidden md:block">Suggest a Feature</span>
            </Button>
          </Link>
        }
      />

      <div className="mt-8">
        <FeaturesRoadmap />
      </div>
    </PageContainer>
  );
}
